'use strict';

const formValidation = require('../components/formValidation');
const alertMessage = require('../utils/alertMessage');

let location = window.location;

module.exports = {
    submitProfile: function () {
        $('form.edit-profile-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        alertMessage(data.msg, 'cc-alert--success');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitPassword: function () {
        $('form.change-password-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        $form.spinner().stop();
                        formValidation($form, data);
                        if (data.fields.dwfrm_profilePassword_login_currentpassword != undefined) {
                            $('.js-current-password .cc-message').addClass('cc-message--visible').text(data.fields.dwfrm_profilePassword_login_currentpassword);
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitSuppliesForm: function () {
        $('form.supplies-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var getRecaptchaToken;

            var captchaSiteKey = $form.data('captcha-key');

            grecaptcha.ready(function () {
                grecaptcha.execute(captchaSiteKey, { action: 'validate_captcha' }).then(function (token) {
                    document.getElementById('gRecaptchaResponse').value = token;
                    
                    var url = $form.attr('action');
                    $form.spinner().start();
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: $form.serialize(),
                        success: function (data) {
                            $form.spinner().stop();
                            if (!data.success) {
                                if (data.msg) {
                                    alertMessage(data.msg, 'cc-alert--danger');
                                }
                            } else {
                                alertMessage(data.msg, 'cc-alert--success');
                                setTimeout(() => {
                                    window.location.reload();
                                }, 3000);
                            }
                        },
                        error: function (err) {
                            if (data.msg) {
                                alertMessage(data.msg, 'cc-alert--danger');
                            }
                            $form.spinner().stop();
                        }
                    });
                    return false;
                });
            });
        });
    }
};
